import { ADD_ITEMS_TO_WISHLIST_ERROR, ADD_ITEMS_TO_WISHLIST_REQUEST } from '../constants/ActionTypes'
import type GenericAction from './types/genericAction.types'

type State = string | null

type Error = {
    errors?: { errorKey: string }[]
}

export type AddItemsToWishlistErrorAction = GenericAction<typeof ADD_ITEMS_TO_WISHLIST_ERROR | typeof ADD_ITEMS_TO_WISHLIST_REQUEST, { error: Error }>

const addItemsToWishlistError = (state: State = null, { type, error }: AddItemsToWishlistErrorAction) => {
    switch (type) {
        case ADD_ITEMS_TO_WISHLIST_ERROR:
            return error.errors?.[0].errorKey
        case ADD_ITEMS_TO_WISHLIST_REQUEST:
            return null
        default:
            return state
    }
}

export default addItemsToWishlistError
